export default "__VITE_ASSET__D1970AB___"